import 'core-js/stable';
import 'regenerator-runtime/runtime';
import VimeoPlayer from '@vimeo/player';
import VideoAbstract from './video-abstract';

export default class Vimeo extends VideoAbstract {
  static getPlayer(iframe) {
    return new VimeoPlayer(iframe);
  }

  autoplay() {
    this.player.setVolume(0);
    this.player.setMuted(true);
    this.player.setLoop(true);
    this.player.play();
  }

  stop() {
    this.player.pause();
    this.player.setCurrentTime(0);
  }

  play() {
    this.player.play();
  }
}
